export interface ArticleItem {
  id: string;
  title: string;
  cover: string;
  category: string;
  summary: string;
  date: string;
  author: string;
  readTime: number;
  tags: string[];
  content: string[];
}

export const articles: ArticleItem[] = [
  {
    id: "xinfan-2026",
    title: "2026 年七月新番抢先看：哪部是你的心头好？",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20seasonal%20lineup%20banner%20with%20sparkling%20comets%20and%20energetic%20characters%2C%20warm%20gold%20and%20coral%20palette%2C%20vibrant%20summer%20sky%2C%20cinematic%20illustration&width=1200&height=800&seq=art-xinfan&orientation=landscape",
    category: "新番",
    summary: "七月新番阵容陆续公开，从热血战斗到治愈日常，这份抢先看清单帮你锁定今夏必追佳作。",
    date: "2026-07-05",
    author: "番剧编辑",
    readTime: 6,
    tags: ["新番", "导览", "2026"],
    content: [
      "随着七月番的阵容陆续公开，今年的夏季新番再次迎来百花齐放的盛况。无论是期待已久的续作，还是极具潜力的全新企划，都能在这次的片单里找到惊喜。",
      "首先要关注的是备受期待的热血战斗类新番，制作团队在画面与分镜上下足了功夫，流畅的打斗配合激昂的配乐，力求给观众带来最纯粹的观看体验。这类作品往往能在一众新番中脱颖而出。",
      "如果你偏爱轻松治愈的风格，那么主打日常与美食的作品一定不容错过。它们用细腻的笔触描绘平凡生活中的温暖瞬间，配上一杯热茶，便是最惬意的追番时光。",
      "本季还有多部改编自人气漫画与轻小说的作品，原作党与动画党都能从中获得不同的乐趣。改编动画在还原经典桥段的同时，也加入了更适合动画表现的精彩处理。",
      "无论你偏好哪种类型，都可以在动漫网的新番索引中快速找到心仪的作品，并一键跳转查看详细资料。追新番，来动漫网一站搞定。",
    ],
  },
  {
    id: "guoman-rise",
    title: "国漫崛起：十部必看的精品动画盘点",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20chinese%20anime%20collage%20with%20wuxia%20and%20myth%20characters%2C%20ink%20wash%20and%20warm%20vermilion%20palette%2C%20gold%20accents%2C%20epic%20composition&width=1200&height=800&seq=art-guoman&orientation=landscape",
    category: "国漫",
    summary: "从东方美学到现代叙事，近十年国漫百花齐放。这份精品盘点带你认识值得一看的本土原创动画。",
    date: "2026-06-18",
    author: "国漫观察",
    readTime: 8,
    tags: ["国漫", "盘点", "推荐"],
    content: [
      "近几年国漫的进步有目共睹，无论是画面技术还是叙事深度，都迈上了一个全新的台阶。越来越多优秀的本土原创动画，用东方美学打动了海内外观众。",
      "在武侠题材上，国漫将水墨意境与流畅动作结合得愈发成熟，飞檐走壁之间尽显侠义风骨。这类作品往往在细节处展现深厚的文化底蕴。",
      "志怪与神话题材同样值得关注，古老传说被赋予了全新的想象，传统元素与现代审美相得益彰，为观众带来了耳目一新的体验。",
      "与此同时，都市与日常生活题材也涌现出许多惊喜，它们贴近现实、情感真挚，让国漫的题材版图更加多元与完整。",
      "如果你正准备入坑国漫，不妨从这份盘点开始。在动漫网的国漫专区，还有更多精品等你发掘。",
    ],
  },
  {
    id: "riman-guide",
    title: "从零开始追番指南：日漫入坑全攻略",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20japanese%20anime%20collection%20with%20classic%20genre%20icons%20and%20warm%20orange%20twilight%2C%20friendly%20illustration%2C%20cozy%20beginner%20guide%20atmosphere&width=1200&height=800&seq=art-guide&orientation=landscape",
    category: "日漫",
    summary: "刚接触日漫不知道从哪里开始？这份入坑攻略从类型选择到追更习惯，帮你轻松找到自己的第一部心头好。",
    date: "2026-05-30",
    author: "编辑部",
    readTime: 5,
    tags: ["日漫", "攻略", "入门"],
    content: [
      "日漫的世界浩如烟海，对于刚入坑的新观众来说，如何选择第一部作品往往是最大的难题。其实只要顺着自己的兴趣出发，追番就会变得轻松愉快。",
      "如果你喜欢燃向的故事，热血与运动题材是绝佳的起点，主角的成长与伙伴的羁绊总能让人热血沸腾。这类作品节奏明快，非常适合入门。",
      "偏爱细腻情感的话，恋爱与治愈题材会带来温暖的观感，它们擅长刻画人与人的关系，配乐与画面都极具氛围感。",
      "喜欢烧脑剧情的朋友则可以尝试悬疑与奇幻作品，层层铺垫的谜题与宏大的世界观，会让你越看越着迷。",
      "确定方向后，记得善用动漫网的分类与日漫检索功能，快速定位同类佳作。愿你找到属于自己的第一部日漫。",
    ],
  },
  {
    id: "zhiyu-list",
    title: "这些治愈系动漫，适合深夜慢慢看",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20healing%20anime%20scene%20of%20cozy%20bedside%20lamp%20and%20warm%20tea%20at%20night%2C%20soft%20cream%20and%20amber%20palette%2C%20gentle%20bokeh%2C%20relaxing%20atmosphere&width=1200&height=800&seq=art-zhiyu&orientation=landscape",
    category: "治愈",
    summary: "忙碌一天之后，让这些温柔治愈的动漫陪你度过宁静的深夜，抚平疲惫，重拾对生活的热爱。",
    date: "2026-05-12",
    author: "夜猫编辑",
    readTime: 4,
    tags: ["治愈", "盘点", "放松"],
    content: [
      "治愈系动漫有着独特的力量，它们不靠激烈的剧情取胜，而是用细水长流的日常温暖人心。深夜独处时，这样的作品最是熨帖。",
      "美食题材是治愈系的常客，一道道热气腾腾的料理背后，是平凡日子里的小确幸。看着角色大快朵颐，仿佛自己的烦恼也被一并治愈了。",
      "日常系作品同样令人放松，它们记录四季流转与点滴小事，平淡却真实，让人在快节奏的生活中慢下脚步。",
      "有些治愈番则藏着一层温柔的内核，在轻快的氛围下传递关于成长、告别与和解的思考，后劲十足。",
      "如果你也需要一点温暖，不妨在动漫网的治愈分类中挑选一部，泡上一杯热茶，静下心来慢慢品味。",
    ],
  },
  {
    id: "jingji-list",
    title: "盘点近十年最燃的热血竞技动画",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20sports%20anime%20collage%20with%20basketball%20baseball%20and%20running%20moments%2C%20warm%20orange%20and%20amber%20palette%2C%20dynamic%20motion%20and%20stadium%20lights%2C%20energetic%20composition&width=1200&height=800&seq=art-jingji&orientation=landscape",
    category: "运动",
    summary: "汗水、呐喊与逆袭，热血竞技动画总能用一场场酣畅淋漓的比赛点燃我们心中的斗志。",
    date: "2026-04-22",
    author: "竞技迷",
    readTime: 7,
    tags: ["运动", "热血", "盘点"],
    content: [
      "热血竞技动画的魅力，在于把体育精神与角色成长紧密相连。每一次训练、每一场比赛，都是对意志与信念的考验。",
      "篮球题材作品将团队协作展现得淋漓尽致，关键时刻的一记绝杀、队友间的默契配合，都让人看得心潮澎湃。",
      "棒球与田径等题材则更强调个人突破，主角在无数次失败后重新站起的瞬间，往往最具感染力。",
      "除了竞技本身，这些作品还刻画了角色在赛场之外的生活，友情、家庭与梦想交织，让燃点之外更添温度。",
      "想重温这些经典，欢迎随时回到动漫网的运动分类，一起为热爱呐喊。",
    ],
  },
  {
    id: "comic-anime",
    title: "漫画改编动画：原著党和动画党谁更幸福？",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20adaptation%20concept%20with%20open%20manga%20book%20and%20animated%20character%20stepping%20out%2C%20warm%20gold%20and%20coral%20palette%2C%20creative%20flat%20illustration&width=1200&height=800&seq=art-comic&orientation=landscape",
    category: "日漫",
    summary: "同一部作品，漫画与动画各有魅力。原著党钟爱细节，动画党享受视听，这究竟是场幸福的烦恼。",
    date: "2026-03-15",
    author: "文化评论",
    readTime: 5,
    tags: ["日漫", "漫改", "话题"],
    content: [
      "当一部人气漫画宣布动画化，总是会引发原著党与动画党的热烈讨论。两者各有拥趸，也各有独特的乐趣。",
      "原著党能在静止的格子里细细品味分镜与笔触，那些藏在画面角落的细节，往往只有耐心阅读才能发现。",
      "动画党则享受声音与动态带来的沉浸体验，精彩的配乐与流畅的动作，让经典场面拥有全新的生命力。",
      "当然，改编也常常伴随取舍，节奏的调整与剧情的删改，有时会引发不小的争议。但无论如何，能让更多人认识这部作品，本身就是一件好事。",
      "无论你站在哪一边，都欢迎在动漫网与同好分享你的看法。毕竟，对作品的热爱才是最重要的。",
    ],
  },
];